import Component from "@glimmer/component";
import ComboBox from "discourse/select-kit/components/combo-box";
import DButton from "discourse/ui-kit/d-button";
import { i18n } from "discourse-i18n";
import { hash, fn } from "@ember/helper";
import { WAZE_SEMI_CATEGORIES } from "../../lib/waze-semi-categories";

export default class WazeSemiCategorySettings extends Component {
  get semiCategories() {
    return WAZE_SEMI_CATEGORIES.map(({ id }) => ({
      id,
      name: i18n(`waze.semi_categories.names.${id}`),
    }));
  }

  <template>
    <@outletArgs.form.Section
      @title={{i18n "waze.semi_categories.settings.waze_semi_category"}}
      class="category-custom-settings-outlet waze-semi-category-settings"
    >
      <@outletArgs.form.Object @name="custom_fields" as |object|>
        <object.Field
          @name="waze_semi_category_id"
          @title={{i18n
            "waze.semi_categories.settings.belongs_to_semi_category"
          }}
          @type="custom"
          @format="max"
          as |field|
        >
          <field.Control>
            <ComboBox
              @id="waze-semi-category"
              @class="input-xxlarge"
              @content={{this.semiCategories}}
              @value={{field.value}}
              @onChange={{field.set}}
              @options={{hash allowAny=false}}
            />
            {{#if field.value}}
              <DButton
                @class="btn-default undo"
                @action={{fn field.set ""}}
                @icon="undo"
                @label="admin.settings.reset"
              />
            {{/if}}
          </field.Control>
        </object.Field>

        <object.Field
          @name="waze_show_semi_category_layout"
          @title={{i18n "waze.semi_categories.settings.show_semi_category"}}
          @description={{i18n
            "waze.semi_categories.settings.show_semi_category_hint"
          }}
          @type="checkbox"
          @format="max"
          as |field|
        >
          <field.Control>
            {{i18n
              "waze.semi_categories.settings.show_semi_category_above_topics"
            }}
          </field.Control>
        </object.Field>
      </@outletArgs.form.Object>
    </@outletArgs.form.Section>
  </template>
}
